import { render, staticRenderFns } from "./GovMenuAssignDialog.vue?vue&type=template&id=7bcb4344&scoped=true&"
import script from "./GovMenuAssignDialog.vue?vue&type=script&lang=js&"
export * from "./GovMenuAssignDialog.vue?vue&type=script&lang=js&"
import style0 from "./GovMenuAssignDialog.vue?vue&type=style&index=0&id=7bcb4344&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcb4344",
  null
  
)

export default component.exports